import React from 'react';
import RemoteVideoMenuTriggerButton from '../../../video-menu/components/web/RemoteVideoMenuTriggerButton';
// eslint-disable-next-line no-confusing-arrow
const VideoMenuTriggerButton = ({ hidePopover, local, participantId = '', popoverVisible, showPopover, thumbnailType, visible }) => local
    ? (React.createElement(React.Fragment, null))
    : (React.createElement("span", { id: 'remotevideomenu' },
        React.createElement(RemoteVideoMenuTriggerButton, { buttonVisible: visible, hidePopover: hidePopover, participantID: participantId, popoverVisible: popoverVisible, showPopover: showPopover, thumbnailType: thumbnailType })));
export default VideoMenuTriggerButton;
